import React, { useState, useEffect } from "react";
// Components
import Preloader from "../../components/Preloader/Preloader";
import MessageBox from "../../components/MessageBox/MessageBox";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { Clear, LoyaltyTwoTone } from "@material-ui/icons";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format, subYears } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";

import {
  get_cookies,
  isLoggedIn,
  timeZoneChanger,
} from "../../components/Cookies/Cookies";
import Input from "@material-ui/core/Input";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { NavLink } from "react-router-dom";

import { Box, Grid, Paper, styled } from "@material-ui/core";
import PopUpModal from "../../components/Modal/PopUpModal";

const CustomGrid = styled(Grid)({
  "&.MuiGrid-spacing-xs-3 > .MuiGrid-item": {
    padding: "12px !important",
    paddingVertical: "8px !important",
  },
});
const useStyles = makeStyles({
  title: {
    marginTop: 0,
    marginBottom: 0,
  },
  field: {
    width: "100%",
  },
  autoComplete: {
    width: "100%",
  },
  date: {
    width: "100%",
  },
  buttonContainer: {
    textAlign: "right",
  },
  input: {
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
});

const FranchiseSet = (props) => {
  const { item } = props.location.state;
  const classes = useStyles();
  const packagesales_home = {
    pathname: "/Franchise",
  };
  const gobacktoHomepage = () => {
    props.history.push(packagesales_home);
  };
  const navid = props.match.params.navid;
  const CurrentPage = props.match.params.package_name;

  //ApiData Component Content Variables
  let initialArray = [
    "trandate",
    //     "dob",
    "conno",
    "refcode",
    "activationcode",
    "warehouse",
    "shipping",
    "transtype",
    "primaryteam",
    "secondaryteam",
  ];
  const [required_fields, setTheRequiredFields] = useState(initialArray);
  const [location_dropdown, loadLocationDropdown] = useState([]);
  const [branchIdNo, setBranchIdNo] = useState(get_cookies("branchidno"));
  const [branchCurcode, setBranchCurcode] = useState(get_cookies("curcode"));
  const [shipping_dropdown, loadShippingDropdown] = useState([]);
  const [team_dropdown, loadTeamDropdown] = useState([]);
  const [isLoaded, setisLoaded] = useState();
  const [isFranchise, setIsFranchise] = useState(true);
  const [nextPagePath, setnextPagePath] = useState("");
  const [shippingChargeVal, setShippingChargeVal] = useState(0);
  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  const minDate = subYears(new Date(), 18);
  const [dateOfbirth, setDateOfBirth] = useState(minDate);
  const [modalOpen, setModalOpen] = useState(false);
  const [messageType, setMessageType] = useState("info");
  const [popUpMessage, setPopUpMessage] = useState("");

  //Message Box EOF
  const headers = {
    "Content-Type": "multipart/form-data",
  };
  //OnLoad Event/Data Fetching

  const [selectedDate, setSelectedDate] = React.useState(null);
  useEffect(() => {
    timeZoneChanger(setSelectedDate);
    isLoggedIn();
    setisLoaded(false);
    get_warehouse();
    get_shipping();
    get_team();
    //   check_if_franchise();
    //   check_if_codesonly();
    setisLoaded(true);
    const newData = { ...prep_data };
    newData["shippingcharge"] = 0;
    newData["transtype"] = "Paid Slot regular";
    newData["transtype_desc"] = "Paid Slot (Regular Account)";
    setData({ ...newData });
  }, []);
  // useEffect(() => {
  // 	console.log('2',selectedDate)
  // 	const newData = { ...prep_data };
  // 	newData["trandate"] = format(new Date(selectedDate),'yyyy-MM-dd');
  // 	newData["shippingcharge"] = 0;
  // 	setData({ ...newData });
  // 	console.log('tes',newData);
  // }, []);

  //Api Functions SOF
  const get_warehouse = () => {
    //get data for warehouse/location dropdown
    const formData = new FormData();
    formData.append("form_data", "");
    const apiUrl = process.env.REACT_APP_API_URL + "warehouse";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadLocationDropdown(res.data.warehouse);
    });
  };

  const get_shipping = () => {
    //get data for shipping location dropdown
    const formData = new FormData();
    formData.append("form_data", "");
    const apiUrl = process.env.REACT_APP_API_URL + "shipping";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadShippingDropdown(res.data.shipping);
    });
  };

  const get_team = () => {
    //get data for shipping location dropdown
    const formData = new FormData();
    formData.append("form_data", "");
    const apiUrl = process.env.REACT_APP_API_URL + "team";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadTeamDropdown(res.data.team);
    });
  };

  const validate_required = () => {
    const apiUrl = process.env.REACT_APP_API_URL + "validate_required";
    const newData = { ...prep_data };
    const form_data = {
      required_fields: required_fields,
      reqfield_obj: prep_data,
    };
    // console.log('data',form_data);
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      if (res.data.result.success == 1) {
        validate_activationno();
      } else {
        setPopUpMessage(res.data.result.message);
        setModalOpen(true);
        setMessageType("error");
        setTimeout(() => {
          setModalOpen(false);
        }, 4000);
      }
    });
  };

  const validate_activationno = () => {
    const apiUrl = process.env.REACT_APP_API_URL + "activationno_isvalid";
    const form_data = {
      idno: prep_data.activationcode,
      hqidno: branchIdNo,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      if (res.data.count > 0) {
        if (isFranchise == true) {
          validate_sponsor();
        } else {
          props.history.push(nextpage);
        }
      } else {
        setPopUpMessage('Invalid Activation No.');
        setModalOpen(true);
        setMessageType("warning");
        setTimeout(() => {
          setModalOpen(false);
        }, 4000);
      }
    });
  };

  const check_if_franchise = () => {
    const apiUrl = process.env.REACT_APP_API_URL + "get_nav_details";
    const form_data = {
      navid: navid,
      curcode: branchCurcode,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      if (res.data.success > 0) {
        if (res.data.package_details.products > 0) {
          setTheRequiredFields((required_fields) => [
            ...required_fields,
            "sponsor_id",
          ]);
          setIsFranchise(true);
        } else {
          setIsFranchise(false);
        }
      } else {
        setShowMsgBox(true);
        setMsg("Missing Navigation ID");
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
        }, 4000);
      }
    });
  };

  const validate_sponsor = () => {
    const apiUrl = process.env.REACT_APP_API_URL + "check_sponsor";
    const form_data = {
      sponsor_id: prep_data.sponsor_id,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      if (res.data.success > 0) {
        props.history.push(nextpage);
      } else {
        setShowMsgBox(true);
        setMsg("Invalid Sponsor ID");
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
        }, 4000);
      }
    });
  };
  // const check_if_codesonly = () => {
  //   const apiUrl = process.env.REACT_APP_API_URL + "is_codesonly";
  //   const form_data = {
  //     navid: navid,
  //   };
  //   const formData = new FormData();
  //   formData.append("form_data", JSON.stringify(form_data));
  //   axios.post(apiUrl, formData, { headers: headers }).then((res) => {
  //     if (res.data.success == 1) {
  //       setnextPagePath(res.data.nextpagepath);
  //     } else {
  //       setShowMsgBox(true);
  //       setMsg("Missing navigation ID");
  //       setMsgType("warning");
  //       setTimeout(() => {
  //         setShowMsgBox(false);
  //       }, 4000);
  //     }
  //   });
  // };
  //Api Request Functions EOF

  const selectShippingProps = {
    options: shipping_dropdown,
    getOptionLabel: (option) => option.description,
  };

  const selectLocationProps = {
    options: location_dropdown,
    getOptionLabel: (option) => option.description,
  };

  const selectTransactionTypeProps = {
    options: selectTransactionType,
    getOptionLabel: (option) => option.description || "",
  };

  const selectTeamProps = {
    options: team_dropdown,
    getOptionLabel: (option) => option.description,
  };

  //FormData SOF
  const [prep_data, setData] = useState({});

  const onInputChange = (event) => {
    const newData = { ...prep_data };
    newData[event.target.name] = event.target.value;

    newData["trandate"] = formatDate(
      format(new Date(selectedDate), "yyyy-MM-dd")
    );
    newData["dob"] = formatDate(format(new Date(dateOfbirth), "yyyy-MM-dd"));
    setData({ ...newData });
  };
  const onInputChangeShipping = (event) => {
    var regex = /^[0-9!@#\$%\^\&*\\(+=._-]+$/g;
    let x = "";
    if (regex.test(event.target.value)) {
      x = event.target.value;
    } else {
      x = "";
    }
    const newData = { ...prep_data };
    newData[event.target.name] = x;
    setData({ ...newData });
    setShippingChargeVal(x);
  };
  const NumberKeyTrapper = (e) => {
    var a = [];
    var k = e.which;

    for (let i = 48; i < 58; i++) {
      a.push(i);
    }

    if (!(a.indexOf(k) >= 0)) {
      e.preventDefault();
    }
  };
  const formatDate = (date) => {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };
  const numericOnly = (event) => {
    var regex = /^\d*\.?\d*$/;
    let x = "";
    if (regex.test(event.target.value)) {
      x = event.target.value;
    } else {
      x = "";
    }
    const y = x.replaceAll("-", "");
    const newData = { ...prep_data };
    newData[event.target.name] = event.target.value;
    setData({ ...newData });
  };
  //FormData EOF
  //FormData Validation SOF
  const nextpage = {
    // pathname: "/package-sales-information",
    pathname: "/Franchise-information",
    transactionInfo: prep_data,
    packageInfo: item, // your data array of objects
    pageInfo: {
      navid: navid,
      navname: CurrentPage,
    },
  };

  //FormData Validation EOF
  return (
    <div className="page">
        <PopUpModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        message={popUpMessage}
        type={messageType}
      />
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        <Breadcrumbs aria-label="breadcrumb">
          <NavLink to="/package-sales">
            <h2 className="header-title">Franchise Set</h2>
          </NavLink>
          <Typography variant="h6" color="textPrimary">
            {item.packagetype} - {item.packagetypename}
          </Typography>
        </Breadcrumbs>
      </div>
      <div className="page-container">
        {}
        {!isLoaded ? (
          <Preloader />
        ) : (
          <form noValidate autoComplete="off">
            <MessageBox
              in={showMsgBox}
              content={msgBoxContent}
              type={msgType}
            />

            <Card>
              <CardContent>
                <h4 className={classes.title}>Wholesaler Information</h4>
                <CustomGrid container spacing={3}>
                  <CustomGrid item xs={12} sm={4}>
                    <TextField
                      name="fname"
                      label="First Name"
                      variant="outlined"
                      type="text"
                      margin="normal"
                      required="true"
                      className={classes.field}
                      onChange={onInputChange}
                    />
                  </CustomGrid>
                  <CustomGrid item xs={12} sm={4}>
                    <TextField
                      name="mname"
                      label="Middle Name"
                      variant="outlined"
                      type="text"
                      margin="normal"
                      required="true"
                      className={classes.field}
                      onChange={onInputChange}
                    />
                  </CustomGrid>
                  <CustomGrid item xs={12} sm={4}>
                    <TextField
                      name="lname"
                      label="Last Name"
                      variant="outlined"
                      type="text"
                      margin="normal"
                      required="true"
                      className={classes.field}
                      onChange={onInputChange}
                    />
                  </CustomGrid>
                </CustomGrid>
                <CustomGrid container spacing={3}>
                  <CustomGrid item xs={12} sm={4}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="MM/dd/yyyy"
                        name="birthdate"
                        label="Birthdate"
                        value={dateOfbirth}
                        inputVariant="outlined"
                        margin="normal"
                        required="true"
                        className={classes.field}
                        onChange={(event) => setDateOfBirth(event)}
                        maxDate={minDate} // Set the minimum date
                        maxDateMessage="You must be at least 18 years old."
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </CustomGrid>
                  <CustomGrid item xs={12} sm={4}>
                    <TextField
                      name="email"
                      label="Email"
                      variant="outlined"
                      type="email"
                      margin="normal"
                      required="true"
                      className={classes.field}
                      onChange={onInputChange}
                    />
                  </CustomGrid>
                  <CustomGrid item xs={12} sm={4}>
                    <TextField
                      name="conno"
                      label="Contact Number"
                      variant="outlined"
                      type="number"
                      margin="normal"
                      required="true"
                      className={classes.field}
                      onChange={onInputChange}
                    />
                  </CustomGrid>
                </CustomGrid>
              </CardContent>
            </Card>

            <Card style={{marginTop:"20px"}}>
              <CardContent>
                <h4 className={classes.title}>Transaction Information</h4>
                <CustomGrid container spacing={3}>
                  <CustomGrid item xs={12} sm={4}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="MM/dd/yyyy"
                        label="Transaction Date"
                        value={selectedDate}
                        inputVariant="outlined"
                        margin="normal"
                        disabled="true"
                        required="true"
                        className={classes.date}
                        onChange={onInputChange}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </CustomGrid>
                  <CustomGrid item xs={12} sm={4}>
                    <TextField
                      name="refcode"
                      label="Reference Code"
                      variant="outlined"
                      type="text"
                      margin="normal"
                      required="true"
                      className={classes.field}
                      onChange={onInputChange}
                    />
                  </CustomGrid>

                  <CustomGrid item xs={12} sm={4}>
                    <Autocomplete
                      {...selectLocationProps}
                      autoComplete
                      includeInputInList
                      className={classes.autoComplete}
                      name="warehouse"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          margin="normal"
                          label="Location"
                          variant="outlined"
                          required="true"
                        />
                      )}
                      onChange={async (event, newValue) => {
                        if (!newValue == "" || !newValue == null) {
                          const newData = {
                            ...prep_data,
                          };
                          newData["warehouse"] = JSON.stringify(
                            newValue.id,
                            null,
                            " "
                          );
                          newData["warehouse_desc"] = newValue.description;
                          setData({ ...newData });
                        } else {
                          const newData = {
                            ...prep_data,
                          };
                          newData["warehouse"] = "";
                          newData["warehouse_desc"] = "";
                          setData({ ...newData });
                        }
                      }}
                    />
                  </CustomGrid>
                </CustomGrid>
                <CustomGrid container spacing={3}>
                  <CustomGrid item xs={12} sm={4}>
                    <Autocomplete
                      {...selectShippingProps}
                      autoComplete
                      includeInputInList
                      className={classes.autoComplete}
                      name="shipping"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Shipping"
                          margin="normal"
                          variant="outlined"
                          required="true"
                        />
                      )}
                      onChange={(event, newValue) => {
                        if (!newValue == "" || !newValue == null) {
                          const newData = {
                            ...prep_data,
                          };
                          newData["shipping"] = JSON.stringify(
                            newValue.id,
                            null,
                            " "
                          );
                          newData["shipping_desc"] = newValue.description;
                          setData({ ...newData });
                        } else {
                          const newData = {
                            ...prep_data,
                          };
                          newData["shipping"] = "";
                          newData["shipping_desc"] = "";
                          setData({ ...newData });
                        }
                      }}
                    />
                  </CustomGrid>
                  <CustomGrid item xs={12} sm={4}>
                    <TextField
                      name="shippingcharge"
                      label="Shipping Charge"
                      variant="outlined"
                      margin="normal"
                      type="number"
                      disabled={
                        prep_data["shipping_desc"] != "Delivery" ? true : false
                      }
                      inputProps={{ min: 0, max: 10 }}
                      step={0.5}
                      value={
                        shippingChargeVal && Math.max(0, shippingChargeVal)
                      }
                      className={classes.field}
                      onChange={onInputChangeShipping}
                      onKeyPress={NumberKeyTrapper}
                    />
                  </CustomGrid>
                  <CustomGrid item xs={12} sm={4}>
                    <TextField
                      name="activationcode"
                      label="Activation Code"
                      variant="outlined"
                      type="text"
                      margin="normal"
                      required="true"
                      className={classes.field}
                      onChange={onInputChange}
                    />
                  </CustomGrid>
                </CustomGrid>
                <CustomGrid container spacing={3}>
                  <CustomGrid item xs={12} sm={4}>
                  <TextField
                        name="sponsor_id"
                        label="Sponsor ID"
                        variant="outlined"
                        type="text"
                        margin="normal"
                        required="true"
                        className={classes.field}
                        onChange={onInputChange}
                      />
                  </CustomGrid>
                  <CustomGrid item xs={12} sm={4}>
                    <Autocomplete
                      {...selectTeamProps}
                      name="primaryteam"
                      autoComplete
                      includeInputInList
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          margin="normal"
                          label="Primary Team"
                          variant="outlined"
                          required="true"
                        />
                      )}
                      onChange={(event, newValue) => {
                        if (!newValue == "" || !newValue == null) {
                          const newData = {
                            ...prep_data,
                          };
                          newData["primaryteam"] = JSON.stringify(
                            newValue.id,
                            null,
                            " "
                          );
                          newData["primaryteam_desc"] = newValue.description;
                          setData({ ...newData });
                        } else {
                          const newData = {
                            ...prep_data,
                          };
                          newData["primaryteam"] = "";
                          newData["primaryteam_desc"] = "";
                          setData({ ...newData });
                        }
                      }}
                    />
                  </CustomGrid>
                  <CustomGrid item xs={12} sm={4}>
                    <Autocomplete
                      {...selectTeamProps}
                      name="secondaryteam"
                      autoComplete
                      includeInputInList
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          margin="normal"
                          label="Secondary Team"
                          variant="outlined"
                          required="true"
                        />
                      )}
                      onChange={(event, newValue) => {
                        if (!newValue == "" || !newValue == null) {
                          const newData = {
                            ...prep_data,
                          };
                          newData["secondaryteam"] = JSON.stringify(
                            newValue.id,
                            null,
                            " "
                          );
                          newData["secondaryteam_desc"] = newValue.description;
                          setData({ ...newData });
                        } else {
                          const newData = {
                            ...prep_data,
                          };
                          newData["secondaryteam"] = "";
                          newData["secondaryteam_desc"] = "";
                          setData({ ...newData });
                        }
                      }}
                    />
                  </CustomGrid>
                </CustomGrid>
                <Box display="flex" justifyContent="flex-end">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={(e) => {
                    validate_required();
                  }}
                >
                  Next
                </Button>
                </Box>
              </CardContent>
            </Card>

            {/* <CustomGrid container>
              <CustomGrid item spacing={3}></CustomGrid>
              <CustomGrid item xs="12" className={classes.buttonContainer}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={(e) => {
                    validate_required();
                  }}
                >
                  Next
                </Button>
              </CustomGrid>
            </CustomGrid> */}
          </form>
        )}
      </div>
    </div>
  );
};

const selectTransactionType = [
  { description: "Paid Slot (Regular Account)", id: "Paid Slot regular" },
];
export default FranchiseSet;
